<div id="rawdata_info" class="tablewrap resizetable tabpage">
  <div class="table">
    <div class="blockheader"></div>
    <table fixedcols="[]" id="rawdatatable">
      <tr>
        <th>
          <input type="checkbox"/>
        </th>
        <th class="datetime_column">{{'Time'|translate }}</th>
        <th class="coordinates_column">{{'Coordinates'|translate }}</th>
        <th class="small_column">{{'Satellites'|translate }}</th>
        <th class="speed_column">{{'Speed'|translate }}</th>
        <th class="mileage_column">{{'Altitude'|translate }}</th>
        <th>{{'Raw data'|translate }}</th>
        <th *ngIf="canAccessComponent(AccessRights.EDITUSERS)"></th>
      </tr>
    </table>
  </div>

  <!--app-pagination [viewmode]="'print excel pages'" [printElementID]="'rawdatatable'"></app-pagination-->
  <app-footer-component [viewMode]="'print excel pages'" [printElementID]="'rawdatatable'">
  </app-footer-component>
</div>
